module.exports = __webpack_public_path__ + "media/images/city_img/k-2fdfd533fd3b7350265c96948bd46d70.jpg";